// LIVE: compute and BE-Light have both deployed, so `:begin` sends `fe_yield` and Add data offers
// Upload yield map.

let live = true;

export function yieldAttachIsLive(): boolean {
  return live;
}

export function setYieldAttachLiveForTests(v: boolean): void {
  live = v;
}
